/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_CURRENT_DISPLAY_OBJ_UNIT = 'GET_CURRENT_DISPLAY_OBJ_UNIT';
export const GET_PLAN_TYPE_DATA_UNIT = 'GET_PLAN_TYPE_DATA_UNIT';
export const GET_REBATE_PROGRAM_UNIT = 'GET_REBATE_PROGRAM_UNIT';
export const SET_LOADING_UNIT_ADJUSTMENT_NDC_LEVEL =
  'SET_LOADING_UNIT_ADJUSTMENT_NDC_LEVEL';
export const GET_REBATE_PROGRAM_NAME_UNIT = 'GET_REBATE_PROGRAM_NAME_UNIT';
export const GET_ERROR_MSG_UNIT = 'GET_ERROR_MSG_UNIT';
export const GET_FROM_UNIT = 'GET_FROM_UNIT';
export const SET_DISPLAY_OBJ_UNIT = 'SET_DISPLAY_OBJ_UNIT';
export const SET_REFRESH_DATA_UNIT = 'SET_REFRESH_DATA_UNIT';
export const REFRESH_DATA_UNIT_DISPLAY = 'REFRESH_DATA_UNIT_DISPLAY';

export const SET_SEARCH_UNIT = 'SET_SEARCH_UNIT';
export const SET_ALL_REBATE_PROGRAM_UNIT = 'SET_ALL_REBATE_PROGRAM_UNIT';
export const SET_ALL_REBATE_PROGRAM_VALUE_UNIT =
  'SET_ALL_REBATE_PROGRAM_VALUE_UNIT';
export const SET_NDC_GRID_DATA_UNIT = 'SET_NDC_GRID_DATA_UNIT';
export const SET_PAGINATION_INDEX_UNIT_ADJUSTMENT_AT_NDC_LEVEL =
  'SET_PAGINATION_INDEX_UNIT_ADJUSTMENT_AT_NDC_LEVEL';
